import { render } from "./indexProduct.vue?vue&type=template&id=37ad24a9"
import script from "./indexProduct.vue?vue&type=script&lang=js"
export * from "./indexProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__